import { TypedOmit } from '@client/new/helpers/types';
import { Col, Row } from '@design-system/components/grid/grid';
import { useState } from 'react';
import { Gallery, GalleryProps } from './Gallery';

export const GalleryWithThumbnails = ({
  className,
  title,

  ...p
}: TypedOmit<
  GalleryProps,
  'fullWidth' | 'showButtons' | 'selected' | 'onChange'
> & {
  title?: React.ReactNode;
  className?: string;
  previewHeight?: number;
  maxWidth?: string;
}) => {
  const [selected, setSelected] = useState(0);
  return (
    <Col className={className} gap="l" style={{ maxWidth: p.maxWidth }}>
      {p.media.length > 1 ? (
        <Row
          style={{
            height: 57,
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
          }}
        >
          <Gallery {...p} selected={selected} onChange={setSelected} />
        </Row>
      ) : null}
      {title ? <Row style={{ justifyContent: 'center' }}>{title}</Row> : null}
      <Row
        style={{
          height: p.previewHeight || 514,
          width: '100%',
          display: 'flex',
          flexDirection: 'row',
        }}
      >
        <Gallery
          fullWidth
          showButtons
          {...p}
          selected={selected}
          onChange={setSelected}
        />
      </Row>
    </Col>
  );
};
